import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

type StaanderChoiceHeaderProps = {
  headingId: string;
  showRemove: boolean;
  onRemove: () => void;
};

export const StaanderChoiceHeader = ({
  headingId,
  showRemove,
  onRemove,
}: StaanderChoiceHeaderProps) => {
  const shouldReduceMotion = useReducedMotion();
  const hiddenRemoval = {
    opacity: 0,
    y: shouldReduceMotion ? 0 : -4,
  };

  return (
    <div className="gg-relative gg-mb-3 gg-mt-6 gg-flex gg-flex-wrap gg-items-baseline gg-justify-between gg-gap-x-4 gg-gap-y-2">
      <p
        id={headingId}
        className="gg-text-base gg-font-bold gg-leading-6 gg-text-dark-blue"
      >
        Ontwerpen met verticaal profiel
      </p>
      <AnimatePresence initial={false} mode="popLayout">
        {showRemove && (
          <motion.button
            key="remove-vertical-profile"
            type="button"
            onClick={onRemove}
            initial={hiddenRemoval}
            animate={{ opacity: 1, y: 0 }}
            exit={hiddenRemoval}
            transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
            className="gg-whitespace-nowrap gg-text-xs gg-font-bold gg-text-secondary-text gg-underline gg-underline-offset-4 hover:gg-text-dark-blue focus-visible:gg-outline focus-visible:gg-outline-2 focus-visible:gg-outline-offset-2 focus-visible:gg-outline-dark-blue"
          >
            Verwijder verticaal profiel
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};
